import React, { useEffect, useState } from 'react';
import Loader from 'bharat-ui/web/Loader';
import Toaster from 'components/atoms/Toaster';
import Routes from 'Routes';
import { getURLParameter, initNativeSupport, showPostpeLoader } from 'utils/nativeSupport';
import { NativeSupportHandlerLegacy } from 'native-support-handler';
import { loadState, removeState, saveState } from 'utils/LocalStorage';
import { useDispatch } from 'react-redux';
import { LanguageSlice, SET_SELECTED_LANGUAGE } from 'Slices';
import { LANGUAGE } from 'utils/CONSTANT';
import { isIOS, showPostPeUI, showTwelvePcUI, showUnityUi, showZillionUi } from 'utils/Utils';
import { HINDI } from 'language/Hindi';
import { ENGLISH } from 'language/English';
import { registerSlice } from 'store';
import LoaderNew from 'components/atoms/Loader';
import history from 'utils/History';
import './App.scss';

registerSlice(LanguageSlice);
removeState('applicationName', true);
removeState('clientName', true);
removeState('paymentStatusSaved', true);
removeState('deviceType', true);
removeState('upiSelected', true);
removeState('vpaId', true);
removeState('backUri', true);
removeState('backUriDeeplink', true);

const pageRoute = getURLParameter(window.location.href, 'pageRoute') || '';
const checkout = getURLParameter(window.location.href, 'checkout') || '';
const pgWebMode = getURLParameter(window.location.href, 'IsPgWebMode') || '';
const wroute = getURLParameter(window.location.href, 'wroute') || '';

if (isIOS() && !pgWebMode) {
	NativeSupportHandlerLegacy.initImmediate();
}

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();
const isShowUnityUi = showUnityUi();
const isShowZillionUi = showZillionUi();

if (checkout === 'JUSPAY') {
	if (pgWebMode) {
		if (wroute === 'thanks') {
			history.push('/thanks');
		} else {
			history.push('/juspay-web-landing');
		}
	} else if (isShowTwelvePcUI || isShowPostPeUI || isShowZillionUi) {
		history.push('/juspay-landing/consumer');
	} else {
		history.push('/juspay-bharatpe-landing');
	}
}

switch (pageRoute) {
	case 'micro-web-view':
		history.push('/juspay-micro-webview');
		break;
	case 'payment-status':
		history.push('/final-payment-status');
		break;
	default:
		break;
}

const App: React.FC = () => {
	const [appInfoLoaded, setAppInfoLoaded] = useState(false);
	const isShowAlternateUi = isShowPostPeUI || isShowUnityUi;
	const dispatch = useDispatch();

	const onLoad = async () => {
		if (pgWebMode) {
			setAppInfoLoaded(true);
			return;
		}
		saveState('deviceType', 'webview', true);
		await initNativeSupport();

		const language: string = loadState(LANGUAGE) || '';
		dispatch(SET_SELECTED_LANGUAGE({ payload: language.toLowerCase() === 'hi' ? HINDI : ENGLISH }));
		setAppInfoLoaded(true);
	};

	if (isShowAlternateUi && pageRoute !== 'micro-web-view') {
		showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
	}

	const getLoader = () =>
		pageRoute === 'micro-web-view' || isShowAlternateUi ? (
			<></>
		) : isShowTwelvePcUI || isShowZillionUi ? (
			<LoaderNew loading loaderType={isShowTwelvePcUI ? '12pc' : 'zillion'} />
		) : (
			<Loader loading />
		);

	const getRouter = () => <Routes />;

	useEffect(() => {
		onLoad();
	}, []);

	return (
		<div>
			{appInfoLoaded ? getRouter() : getLoader()}
			<Toaster />
		</div>
	);
};

export default App;
